export const DESCRIPTIVE_LISTING = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.DescriptiveListingWidgetElement';
